import React from "react";
import styles from "./Checkbox.module.scss";
import Message from "../Message";
import {CheckboxPropsInterface} from "./Checkbox.props.interface";

const Checkbox: React.FC<CheckboxPropsInterface> = (
    {
        size = 'medium',
        value = false,
        error = undefined,
        disabled = false,
        children = undefined,
        className = undefined,
        onChange,
        ...rest
    }) => {

    const handleGenerateClass = () => {
        return [
            styles.container,
            size ? styles[size] : styles.medium,
            value ? styles.checked : null,
            disabled ? styles.disabled : null,
            error ? styles.error : null,
            className
        ].filter(x => x ?? x).join(' ')
    }

    return (
        <label
            htmlFor={rest.id}
            className={handleGenerateClass()}
        >
            <input
                type="checkbox"
                id={rest.id}
                checked={value}
                onChange={({target}) => onChange ? onChange(target.checked) : null}
            />

            <div className={styles.checkmark}/>

            {children}

            {error ? <Message
                type={'danger'}
                children={error}
            /> : null}

        </label>
    )
};

export default Checkbox;
